
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Custom, Dict } from "@/script/apps/system/entity/SystemEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CustomService } from "@/script/apps/system/service/CustomService";
import { DictService } from "@/script/apps/system/service/DictService";
import { DictUtil } from "@/script/core/Dict";
import { ElMessage } from "element-plus";

@Options({})
export default class CustomDetail extends BaseDetail {
  private service = new CustomService();

  private customDeleteDetails: CustomDetail[] = [];

  protected fieldTypes: Dict[] = [];

  private error: string | null = null;

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
  };

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "sys_custom",
      "/sys/custom",
      "/sys/custom",
      this.service
    );
    data.typesName = "sys-custom-type";
    return data;
  }

  public newEntity() {
    const entity: Custom = { customDetails: [], customDeleteDetails: [] };
    this.injectDetailData(entity.customDetails!, entity.customDeleteDetails!);
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    const dictService = new DictService();
    dictService.loadChildItems("sys-custom-field-type", (data: any) => {
      this.fieldTypes = data;
    });
  }

  public afterLoad(data: any) {
    const custom = this.entity as Custom;
    custom.customDeleteDetails = [];
    this.injectDetailData(custom.customDetails!, custom.customDeleteDetails!);
    this.generateRowNo();
    if (custom.customDetails) {
      custom.customDetails.forEach((item) => {
        item.typeName = DictUtil.getItemName(this.fieldTypes, item.type);
      });
    }
  }

  public beforeSave() {
    const custom = this.entity as Custom;
    if (custom.customDetails) {
      const errors: string[] = [];
      custom.customDetails.forEach((item) => {
        if (this.isEmpty(item.name)) {
          errors.push(`第 [${item.no}] 行的 [字段名称] 不能为空！`);
        }
        if (this.isEmpty(item.label)) {
          errors.push(`第 [${item.no}] 行的 [显示名称] 不能为空！`);
        }
        if (this.isEmpty(item.type)) {
          errors.push(`第 [${item.no}] 行的 [字段类型] 不能为空！`);
        }
      });
      console.info(errors);
      if (errors.length > 0) {
        this.error = errors.join("");
        ElMessage.error(`验证表格内容失败!具体原因请查看表格上方提示。`);
        return false;
      } else {
        this.error = null;
      }
    }

    return true;
  }

  private isEmpty(value: string | null | undefined): boolean {
    if (value === undefined) {
      return true;
    }
    if (value === null) {
      return true;
    }
    value = value.trim();
    if (value.length === 0) {
      return true;
    }
    return false;
  }

  private fieldTypeChange(row: any) {
    row.typeName = DictUtil.getItemName(this.fieldTypes, row.type);
  }
}
